export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    let columns = [
      {
        title: '保单号',
        key: 'policyNo',
        align: 'center',
        fixed: 'left',
        minWidth: 160
      },
      {
        title: '所属组织',
        minWidth: 200,
        key: 'orgName',
        align: 'center',
        render(h, params) {
          const orgName = params.row.orgName;
          const groupName = params.row.groupName;
          return <span>{groupName ? orgName + '/' + groupName : orgName}</span>;
        }
      },
      {
        title: '出单业务员',
        key: 'salesmanName',
        align: 'center',
        minWidth: 160
      },
      {
        title: '保单状态',
        slot: 'policyStatus',
        align: 'center',
        minWidth: 110
      },
      {
        title: '产品名称',
        key: 'productName',
        align: 'center',
        minWidth: 160
      },
      {
        title: '附加险名称',
        key: 'additionName',
        align: 'center',
        minWidth: 160,
        render(h, params) {
          const text = params.row.additionName || '-';
          return <span>{text}</span>;
        }
      },
      {
        title: '投/被保人',
        slot: 'policyerName',
        align: 'center',
        minWidth: 130,
        render(h, params) {
          const text = params.row.insuranceName ? params.row.policyerName + ' / ' + params.row.insuranceName : params.row.policyerName;
          return <span>{text}</span>;
        }
      },
      {
        title: '应续日期/宽限到期',
        slot: 'needPayDate',
        align: 'center',
        minWidth: 180,
        render(h, params) {
          const needPayDate = params.row.needPayDate.split(" ")[0].replace(/-/g,"/");
          const lastPayDate = params.row.lastPayDate.split(" ")[0].replace(/-/g,"/");
          return <span>{needPayDate} - {lastPayDate}</span>;
        }
      },
      {
        title: '续费年度',
        key: 'curRenewalYears',
        align: 'center',
        width: 100
      },
      {
        title: '结算应收保费/结算实收保费',
        key: 'settlementFee',
        align: 'center',
        minWidth: 190,
        render(h, params) {
          return (
            <span>
              {params.row.settlementFee || 0} / {params.row.settlementPayFee || 0}
            </span>
          );
        }
      },
      {
        title: '续费状态',
        slot: 'renewalStatus',
        align: 'center',
        width: 110
      },
    ];

    this.columns = columns;
  },
  methods: {}
};
